import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { ServicePointIdReference } from 'src/app/shared/models/referenceData'
import { SelectMenuSearchComponent } from '../table/filters/select-menu-search/select-menu-search.component'
import { FilterSearchMeta, FilterSearchState } from 'src/app/shared/utilities/filter-search-state'
import { Subscription } from 'rxjs'
import { ReferenceDataService } from '../reference-data/reference-data.service'
import { SelectMenuListComponent } from '../table/filters/select-menu-list/select-menu-list.component'
import { SelectMenuListItemComponent } from '../table/filters/select-menu-list-item/select-menu-list-item.component'
import {
  SelectMenuListloadingComponent,
} from '../table/filters/select-menu-list-loading-item/select-menu-list-loading-item.component'
import {
  SelectMenuListErrorComponent,
} from '../table/filters/select-menu-list-error-item/select-menu-list-error-item.component'
import {
  SelectMenuListNoItemsComponent,
} from '../table/filters/select-menu-list-no-items-item/select-menu-list-no-items-item.component'
import {
  SelectMenuListPagingComponent,
} from '../table/filters/select-menu-list-paging-item/select-menu-list-paging-item.component'
import {
  SelectMenuListDividerComponent,
} from '../table/filters/select-menu-list-divider-item/select-menu-list-divider-item.component'
import {
  SelectMenuListNamedSectionComponent,
} from '../table/filters/select-menu-list-named-section-item/select-menu-list-named-section-item.component'
import { ServicePointFilter } from 'src/app/shared/services/filter/service-point-filter'

@Component({
  imports: [
    MatIcon,
    SelectMenuSearchComponent,
    SelectMenuListComponent,
    SelectMenuListItemComponent,
    SelectMenuListNamedSectionComponent,
    SelectMenuListDividerComponent,
    SelectMenuListloadingComponent,
    SelectMenuListNoItemsComponent,
    SelectMenuListPagingComponent,
    SelectMenuListErrorComponent,
  ],
  selector: 'div[app-service-point-selector]',
  template: `
    <div class="wrapper" [class.slim]="slim">
      <mat-icon
        class="search-icon"
        svgIcon="search"
        (click)="toggle()"
        [class.disabled]="disabled"
      ></mat-icon>
      <input
        type="button"
        [placeholder]="'none'"
        [value]="displayText"
        [disabled]="disabled"
        (click)="toggle()"
      />
      <div class="popover" [class.open]="open">
        <div
          app-select-menu-search
          name="service_point_id"
          label="Service Point"
          [value]="searchMeta?.searchTerm ?? ''"
          (search)="this.searchState.search($event)"
        ></div>
        <ul app-select-menu-list (scroll)="onScroll($event)">
          @if(allowPartial && (searchMeta?.searchTerm || selectedPartialValue))
          { @if (selectedPartialValue || searchMeta?.searchTerm) {
          <li app-select-menu-list-named-section-item name="Search"></li>
          } @if(searchMeta?.searchTerm) {
          <li
            app-select-menu-list-item
            [value]="searchMeta?.searchTerm!"
            [display]="searchMeta?.searchTerm!"
            [selected]="searchMeta?.searchTerm === selectedPartialValue"
            [multi]="!!config.allowMultiple"
            (select)="setPartialValue($event)"
            label="Current Search"
          ></li>
          } @if(selectedPartialValue) {
          <li
            app-select-menu-list-item
            [value]="selectedPartialValue"
            [display]="selectedPartialValue"
            [selected]="true"
            [multi]="!!config.allowMultiple"
            (select)="setPartialValue($event)"
            label="Selected Search"
          ></li>
          } @if (selectedPartialValue || searchMeta?.searchTerm) {
          <li app-select-menu-list-divider-item></li>
          } } @for(result of selectedServicePointsMap; track result[0]; let first =
          $first, last = $last) { @if(first) {
          <li app-select-menu-list-named-section-item name="Selected"></li>
          }
          <li
            app-select-menu-list-item
            [value]="result[1]"
            [display]="result[1].service_point_id"
            [selected]="true"
            [multi]="!!config.allowMultiple"
            (select)="setValue($event)"
          ></li>
          @if(last) {
          <li app-select-menu-list-divider-item></li>
          } }
          <!-- SHOW LOADING INDICATOR -->
          @if(searchMeta?.searching) {
          <li app-select-menu-list-loading-item></li>
          }

          @else if(searchMeta?.error ) {
          <li app-select-menu-list-error-item></li>
          }

          @else {
          @for (result of searchResults; track result.service_point_id;) {
          <li
            app-select-menu-list-item
            [value]="result"
            [display]="result.service_point_id"
            [selected]="
              selectedServicePointsMap
                ? selectedServicePointsMap.has(result.service_point_uid)
                : result.service_point_uid === value?.service_point_uid
            "
            [multi]="!!config.allowMultiple"
            (select)="setValue($event)"
          ></li>
          }

          <!-- SHOW NO RESULTS -->
          @if(!searchResults.length) {
          <li app-select-menu-list-no-items-item></li>
          }

          <!-- SHOW PAGING -->
          @if(searchMeta?.paging ) {
          <li app-select-menu-list-paging-item></li>
          } }
        </ul>
      </div>
    </div>
  `,
  styles: `
    .wrapper {
      position: relative;
      width: 100%;
      padding: 0.5rem 0.75rem;
      border: 1px solid black;

      &.slim {
        padding: 0.5rem 0 0;
        border: none; 
      }
    }

    input {
      width: 100%;
      padding: 0.5rem 1.75rem 0.25rem 0.25rem;
      border: none;
      background: white;
      text-align: left;
      border-bottom: 1px solid black;
      font-size: 0.9rem;
      line-height: 1.25rem;

      &:focus {
        outline: none;
      }
    }

    .search-icon {
      position: absolute;
      top: 0.75rem;
      right: 0.25rem;
    }
  
    .popover {
      display: none;
      position: absolute;
    }

    .popover.open {
      z-index: 3;
      display: flex;
      flex-direction: column;
      min-height: 7rem;
      width: 300px;
      right: 0;
      top: calc(100% + 0.5rem);
      border: 1px solid black;
      border-radius: 0;
      padding: 0.5rem 1rem;
      background: white;


      &::before {
        content: ' ';
        border: none;
        border-top: 1px solid black;
        border-right: 1px solid black;
        width: 0.5rem;
        height: 0.5rem;
        transform: rotate(-45deg);
        position: absolute;
        top: calc(-0.25rem - 1px);
        background: linear-gradient(
          45deg, 
          rgba(255,255,255,0) 0%, 
          rgba(255,255,255,0) calc(50% - 1px), 
          rgba(255,255,255,1) calc(50% - 1px), 
          rgba(255,255,255,1) 100%
          );
        right: 1rem;
      }
    }
  `,
})
export class ServicePointSelectorComponent implements OnInit, OnDestroy {
  elementRef = inject(ElementRef)
  referenceDataService = inject(ReferenceDataService)
  changeDetectorRef = inject(ChangeDetectorRef)

  @Input() value: ServicePointIdReference | null = null
  @Input() selectedPartialValue: string | null = null
  @Input() slim = false
  @Input() allowPartial = false
  @Input() disabled = false
  selectedServicePointsMap: Map<string, ServicePointIdReference> | undefined
  @Input() set selectedServicePoints(val:
    | Map<string, ServicePointIdReference>
    | readonly ServicePointIdReference[]
    | undefined,
  ) {
    if (Array.isArray(val)) {
      this.selectedServicePointsMap = new Map(val.map(v => [v.service_point_uid, v]))
    } else {
      this.selectedServicePointsMap = val as Map<string, ServicePointIdReference> | undefined
    }

  }
  @Input() config: Omit<ServicePointFilter['state']['config'], 'meta'>

  @Output() valueChange = new EventEmitter<ServicePointIdReference>()
  @Output() partialValueChange = new EventEmitter<string>()

  open = false
  subscription = new Subscription()
  searchResults: ServicePointIdReference[] = []
  searchMeta?: FilterSearchMeta
  searchState: FilterSearchState<ServicePointIdReference>
  searchStateMeta: FilterSearchState<ServicePointIdReference>

  get displayText() {
    if (this.selectedServicePointsMap) {
      const size =
        this.selectedServicePointsMap.size + (this.selectedPartialValue ? 1 : 0)
      if (!size) {
        return 'None Selected'
      }
      return size > 1
        ? `${size} Selected`
        : this.selectedPartialValue ??
            [...this.selectedServicePointsMap.values()][0]?.service_point_id
    }
    if (this.selectedPartialValue && this.value) {
      return '2 Selected'
    }
    return (
      this.selectedPartialValue ??
      this.value?.service_point_id ??
      'None Selected'
    )
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (
      this.open &&
      !this.elementRef.nativeElement.contains(event.target as Node)
    ) {
      this.toggle()
    }
  }

  ngOnInit(): void {
    this.searchState = new FilterSearchState<ServicePointIdReference>(
      ((searchTerm: string, pageNumber: number, pageSize: number) =>
        this.referenceDataService.servicePoints(
          { pageNumber, pageSize },
          [
            {
              name: 'service_point_id_search',
              values: [{ value: searchTerm }],
            },
          ],
        )),
    )
    this.subscription.add(
      this.searchState.results$.subscribe((r) => {
        this.searchResults = r.filter(
          (r) =>
            !(
              this.selectedServicePointsMap?.has(r.service_point_uid)
            ),
        )
        this.changeDetectorRef.detectChanges()
      }),
    )
    this.subscription.add(
      this.searchState.meta$.subscribe((m) => {
        this.searchMeta = m
        this.changeDetectorRef.detectChanges()
      }),
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  toggle(): void {
    if (!this.disabled) {
      this.open = !this.open
      this.searchState.search('')
    }
  }

  onScroll(evt: Event) {
    const { scrollHeight, scrollTop, clientHeight } = evt.target as Element
    const threshold = 15
    const reachedThreshold =
      Math.abs(scrollHeight - clientHeight - scrollTop) < threshold
    if (
      this.searchMeta?.hasMore &&
      reachedThreshold &&
      !this.searchMeta.paging &&
      !this.searchMeta.searching
    ) {
      this.searchState.page()
    }
  }

  setValue(event: ServicePointIdReference) {
    this.value = event
    this.valueChange.emit(event)
    if (!this.config.allowMultiple) {
      this.open = false
    }
  }

  setPartialValue(event: string) {
    this.selectedPartialValue = event === this.selectedPartialValue ? null : event
    this.partialValueChange.emit(event)
    if (!this.config.allowMultiple) {
      this.open = false
    }
  }
}
